import { lazyLoad } from 'utils/loadable';
import { SplashScreen } from 'app/components/ui/Splash';

export const Dashboard = lazyLoad(
  () => import('./index'),
  module => module.Dashboard,
  {
    fallback: <SplashScreen />,
  },
);
